import { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faCalendarAlt,
    faUserClock,
    faUserTie,
    faComment,
    faSave,
    faTimes,
    faChevronDown,
} from '@fortawesome/free-solid-svg-icons'
import Aside from '../../component/aside'
import Navbar from '../../component/navbar'
import Loading from '../../component/loading'
import RequestQueue from '../../api/requestQueue'
import { toast } from 'react-toastify'
import { ValidForm } from '../../component/validForm'
import FurloughSelectTime from '../../component/furloughSelectTime'
import { DateObject } from 'react-multi-date-picker'
import persian from 'react-date-object/calendars/persian'
import persian_fa from 'react-date-object/locales/persian_fa'
import { formatSecondsToTime } from '../../component/formatSecondsToTime'
import { UnixToDate } from '../../component/unixtodate'
import { AppContextMenu } from '../../App'

function validateTimeRange(minMax, timeRange) {
    // تبدیل زمان‌ها به دقیقه برای مقایسه آسان
    const timeToMinutes = (timeStr) => {
        if (!timeStr) return null // برای مقادیر undefined
        const [hours, minutes] = timeStr.split(':').map(Number)
        return hours * 60 + minutes
    }

    // تبدیل رشته‌های زمان به دقیقه
    const minMinutes = timeToMinutes(minMax.min)
    const maxMinutes = timeToMinutes(minMax.max)
    const fromMinutes = timeToMinutes(timeRange.from)
    const toMinutes = timeToMinutes(timeRange.to)

    // بررسی‌های اولیه اعتبارسنجی
    if (fromMinutes >= toMinutes) {
        return {
            isValid: false,
            message: 'زمان شروع باید قبل از زمان پایان باشد',
        }
    }

    if (fromMinutes < minMinutes) {
        return {
            isValid: false,
            message: `زمان شروع نمی‌تواند قبل از ${minMax.min} باشد`,
        }
    }

    if (toMinutes > maxMinutes) {
        return {
            isValid: false,
            message: `زمان پایان نمی‌تواند بعد از ${minMax.max} باشد`,
        }
    }

    return { isValid: true, message: 'محدوده زمانی معتبر است' }
}

function FurloughGetAdd() {
    const { updateValue } = useContext(AppContextMenu)
    useEffect(() => {
        updateValue('furlough')
    }, [])
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()
    const [furloughMonthTime, setFurloughMonthTime] = useState('')
    const [addData, setAddData] = useState({
        discription: '',
        typeFurlough: '',
    })
    const [organizationWorkingHour, setOrganizationWorkingHour] = useState(null)
    const [selectedDate, setSelectedDate] = useState()
    const [selectedTimeFrom, setSelectedTimeFrom] = useState(null)
    const [selectedTimeTo, setSelectedTimeTo] = useState(null)
    let user = JSON.parse(localStorage.getItem('authResult'))
        ? JSON.parse(localStorage.getItem('authResult'))
        : { role: '' }

    const [timeRange, setTimeRange] = useState({
        min: '0',
        max: '0',
        breakFrom: undefined,
        breakTo: undefined,
    })
    // Check auth
    useEffect(() => {
        if (!JSON.parse(localStorage.getItem('authResult'))) {
            navigate('/login')
        }
        getMyOrganization()
        getFurloughMonth()
    }, [])

    // API calls
    const getFurloughMonth = async () => {
        await RequestQueue.sendRequest({
            config: {
                method: 'get',
                url: `/furlough-request/current-month/${user.user.id}`,
            },
            resolve: (res) => {
                setFurloughMonthTime(res.data)
                setLoading(false)
            },
            reject: (error) => {
                setLoading(false)
                showError('خطا در دریافت اطلاعات مرخصی ماه جاری')
            },
        })
    }

    const getMyOrganization = async () => {
        setLoading(true)
        await RequestQueue.sendRequest({
            config: {
                method: 'get',
                url: `/organization/my`,
            },
            resolve: (res) => {
                if (res.data.currentUserShift?.organizationWorkingHour) {
                    setOrganizationWorkingHour(
                        res.data.currentUserShift?.organizationWorkingHour
                    )
                } else {
                    navigate(-1)
                    showError('شیفت کاری برای شما تعریف نشده است')
                }
                setLoading(false)
            },
            reject: (error) => {
                setLoading(false)
                showError('خطا در دریافت اطلاعات سازمان')
            },
        })
    }

    // Handlers
    const handleInputChange = (e) => {
        const { name, value } = e.target
        setAddData((prev) => ({ ...prev, [name]: value }))
    }

    const handleTypeChange = (type) => {
        setAddData((prev) => ({ ...prev, typeFurlough: type }))
    }

    const handleSubmit = async () => {
        let vaild = ValidForm([
            {
                valueData: addData.discription,
                textData: 'لطفا درجه فوریت را انتخاب کنید.',
            },
            {
                valueData: addData.typeFurlough,
                textData: '.لطفا نوع مرخصی را وارد کنید.',
            },
        ])

        if (vaild.length !== 0) {
            vaild.map((v) => {
                toast.error(v, {
                    position: 'bottom-center',
                })
            })
        } else {
            if (
                validateTimeRange(timeRange, {
                    from: selectedTimeFrom.hour + ':' + selectedTimeFrom.minute,
                    to: selectedTimeTo.hour + ':' + selectedTimeTo.minute,
                }).isValid
            ) {
                setLoading(true)

                const payload = {
                    start_date: handlerResultDate(
                        selectedDate,
                        selectedTimeFrom
                    ),
                    end_date: handlerResultDate(selectedDate, selectedTimeTo),
                    furlough_hour: handlerMinesFromToTime(
                        selectedTimeFrom,
                        selectedTimeTo,
                        timeRange
                    ),
                    description: addData.discription,
                    type_furlough: addData.typeFurlough,
                    substitute_person_id: null,
                }

                await RequestQueue.sendRequest({
                    config: {
                        method: 'post',
                        url: `/furlough-request`,
                        data: payload,
                    },
                    resolve: (res) => {
                        toast.success('درخواست مرخصی با موفقیت ثبت شد', {
                            position: 'bottom-center',
                        })
                        navigate(-1)
                        setLoading(false)
                    },
                    reject: (error) => {
                        setLoading(false)
                        if (error?.response?.data?.message) {
                            showError(error?.response?.data?.message)
                        } else {
                            showError('خطا در ثبت درخواست مرخصی')
                        }
                    },
                })
            } else {
                showError(
                    validateTimeRange(timeRange, {
                        from:
                            selectedTimeFrom.hour +
                            ':' +
                            selectedTimeFrom.minute,
                        to: selectedTimeTo.hour + ':' + selectedTimeTo.minute,
                    }).message
                )
            }
        }
    }

    // Helper functions
    const showError = (message) => {
        toast.dismiss()
        toast.error(message, { position: 'bottom-center' })
    }

    const handlerResultDate = (date, time) => {
        try {
            if (!date) return '';
            
            // تبدیل مقادیر ساعت و دقیقه به عدد
            const hour = parseInt(time?.hour || 0);
            const minute = parseInt(time?.minute || 0);
            
            // استفاده از تاریخ شمسی انتخاب شده
            const persianDate = new DateObject({
                date,
                calendar: persian,
                locale: persian_fa,
            });
            
            // تبدیل به تاریخ میلادی
            const gregorianDate = persianDate.convert();
            
            // گرفتن سال، ماه و روز از تاریخ میلادی
            let year = gregorianDate.year;
            let month = gregorianDate.month.number; // ماه در DateObject از 1 شروع می‌شود
            let day = gregorianDate.day;
            
            // تبدیل ساعت و دقیقه زمان تهران به UTC (کم کردن 3:30 ساعت)
            let utcHour = hour - 3;
            let utcMinute = minute - 30;
            
            // اصلاح دقیقه و ساعت در صورت منفی شدن
            if (utcMinute < 0) {
                utcMinute += 60;
                utcHour -= 1;
            }
            if (utcHour < 0) {
                utcHour += 24;
                // اگر ساعت منفی شد، یک روز از تاریخ کم می‌کنیم
                const prevDate = new DateObject({
                    date: `${year}-${month}-${day}`,
                    format: "YYYY-MM-DD"
                }).subtract(1, "day");
                
                year = prevDate.year;
                month = prevDate.month.number;
                day = prevDate.day;
            }
            
            // ساخت مستقیم رشته ISO بدون استفاده از Date یا getTimezoneOffset
            // فرمت: YYYY-MM-DDTHH:mm:ss.000Z برای زمان UTC
            const pad = (num) => num.toString().padStart(2, '0');
            const isoString = `${year}-${pad(month)}-${pad(day)}T${pad(utcHour)}:${pad(utcMinute)}:00.000Z`;
            
            console.log('ISO string generated (UTC):', isoString);
            return isoString;
        } catch (error) {
            console.error('خطا در تبدیل تاریخ و زمان:', error);
            return '';
        }
    }

    const handlerMinesFromToTime = (fromTime, toTime, minMax) => {
        const timeToSeconds = (time) =>
            (time?.hour || 0) * 3600 + (time?.minute || 0) * 60

        const stringToSeconds = (timeStr) => {
            if (!timeStr) return 0
            const [hour, minute] = timeStr.split(':').map(Number)
            return hour * 3600 + minute * 60
        }

        const fromSeconds = timeToSeconds(fromTime)
        const toSeconds = timeToSeconds(toTime)

        if (toSeconds < fromSeconds) return null

        let totalDuration = toSeconds - fromSeconds

        if (minMax?.breakFrom && minMax?.breakTo) {
            const breakFromSec = stringToSeconds(minMax.breakFrom)
            const breakToSec = stringToSeconds(minMax.breakTo)

            // فقط وقتی بازه استراحت داخل بازه انتخابی باشه، ازش کم کن
            const overlapStart = Math.max(fromSeconds, breakFromSec)
            const overlapEnd = Math.min(toSeconds, breakToSec)

            if (overlapStart < overlapEnd) {
                const breakDuration = overlapEnd - overlapStart
                totalDuration -= breakDuration
            }
        }

        return totalDuration
    }

    // start_date: handlerResultDate(
    //     selectedDate,
    //     selectedTimeFrom
    // ),
    //     end_date: handlerResultDate(selectedDate, selectedTimeTo),

    // console.log(
    //     handlerResultDate(selectedDate, selectedTimeFrom),
    //     'selectedDate'
    // )
    // console.log(selectedTimeFrom, 'selectedTimeFrom')
    // console.log(selectedTimeTo, 'selectedTimeTo')

    console.log(handlerResultDate(selectedDate, selectedTimeFrom), 'wwwwww')
    return (
        <>
            {loading && <Loading />}
            <div className="container">
                <Aside />
                <main className="main-content">
                    <Navbar />

                    <div className="bg-white rounded-xl shadow-lg  border border-gray-200 mx-4 my-6">
                        {/* Header */}
                        <div className="px-6 py-5 border-b border-gray-200 bg-gradient-to-r from-indigo-600 to-purple-600 rounded-xl">
                            <h2 className="text-2xl font-bold text-white">
                                <FontAwesomeIcon
                                    icon={faCalendarAlt}
                                    className="ml-2"
                                />
                                درخواست مرخصی جدید
                            </h2>
                        </div>

                        {/* Summary Card */}
                        <div className="px-6 py-4 bg-red-50 border-b border-red-100">
                            <div className="text-center text-red-800 font-medium">
                                مرخصی استفاده شده: {user?.user?.fullName || ''}
                                {furloughMonthTime && (
                                    <span className="block md:inline">
                                        {' '}
                                        {
                                            furloughMonthTime.totalConfirmedFurloughs
                                        }{' '}
                                        روز و{' '}
                                        {formatSecondsToTime(
                                            furloughMonthTime.totalFurloughHours
                                        )}{' '}
                                        ساعت
                                    </span>
                                )}
                            </div>
                        </div>

                        {/* Form Content */}
                        <div className="p-6 space-y-6">
                            {/* Leave Type */}
                            <div className="space-y-2">
                                <label className=" text-sm font-medium text-gray-700 flex items-center">
                                    <FontAwesomeIcon
                                        icon={faUserClock}
                                        className="ml-2"
                                    />
                                    نوع مرخصی
                                </label>
                                <div className="flex space-x-4  maxLg:flex-col">
                                    <label className="inline-flex items-center maxLg:my-2">
                                        <input
                                            type="radio"
                                            name="typeFurlough"
                                            className="form-radio h-5 w-5 text-indigo-600"
                                            checked={
                                                addData.typeFurlough ===
                                                'hourly'
                                            }
                                            onChange={() =>
                                                handleTypeChange('hourly')
                                            }
                                        />
                                        <span className="mr-2">
                                            مرخصی ساعتی
                                        </span>
                                    </label>
                                    <label className="inline-flex items-center maxLg:my-2">
                                        <input
                                            type="radio"
                                            name="typeFurlough"
                                            className="form-radio h-5 w-5 text-indigo-600"
                                            checked={
                                                addData.typeFurlough === 'daily'
                                            }
                                            onChange={() =>
                                                handleTypeChange('daily')
                                            }
                                        />
                                        <span className="mr-2">
                                            مرخصی روزانه
                                        </span>
                                    </label>
                                </div>
                            </div>

                            {/* Date/Time Picker */}
                            {addData.typeFurlough &&
                                organizationWorkingHour && (
                                    <FurloughSelectTime
                                        typeFurlough={addData.typeFurlough}
                                        selectedDate={selectedDate}
                                        setSelectedDate={setSelectedDate}
                                        selectedTimeFrom={selectedTimeFrom}
                                        setSelectedTimeFrom={
                                            setSelectedTimeFrom
                                        }
                                        selectedTimeTo={selectedTimeTo}
                                        setSelectedTimeTo={setSelectedTimeTo}
                                        organizationWorkingHour={
                                            organizationWorkingHour
                                        }
                                        handlerMinMaxTime={(value) => {
                                            setTimeRange(value)
                                        }}
                                    />
                                )}

                            {/* Urgency Level */}
                            <div className="space-y-2">
                                <label className=" text-sm font-medium text-gray-700 flex items-center">
                                    <FontAwesomeIcon
                                        icon={faComment}
                                        className="ml-2"
                                    />
                                    درجه فوریت:
                                </label>
                                <select
                                    name="discription"
                                    value={addData.discription}
                                    onChange={handleInputChange}
                                    required
                                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                                >
                                    <option value="">انتخاب کنید</option>
                                    <option value="عادی">عادی</option>
                                    <option value="ضروری">ضروری</option>
                                    <option value="خیلی ضروری">
                                        خیلی ضروری
                                    </option>
                                </select>
                            </div>

                            {/* Form Actions */}
                            <div className="flex justify-end space-x-3 space-x-reverse pt-6 maxLg:flex-col">
                                <button
                                    type="button"
                                    onClick={() => navigate(-1)}
                                    className="px-6 maxLg:my-2 py-3 border border-gray-300 rounded-xl text-gray-700 bg-white hover:bg-gray-50 transition-colors flex items-center"
                                >
                                    <FontAwesomeIcon
                                        icon={faTimes}
                                        className="ml-2"
                                    />
                                    انصراف
                                </button>
                                <button
                                    type="button"
                                    onClick={handleSubmit}
                                    className="px-6 maxLg:my-2 py-3 rounded-xl text-white bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 transition-all shadow-md hover:shadow-lg flex items-center"
                                >
                                    <FontAwesomeIcon
                                        icon={faSave}
                                        className="ml-2"
                                    />
                                    ثبت درخواست
                                </button>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </>
    )
}

export default FurloughGetAdd
